(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apply-warranty"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('warranty-apply-form');
    const popup = document.querySelector('#warranty-popup');
    const closeBtn = document.querySelector('#close-popup');

    // CAPTCHA Logic
    const captchaQuestion = document.getElementById('captcha-question');
    const captchaAnswer = document.getElementById('captcha-answer');
    const captchaExpected = document.getElementById('captcha-expected');

    function generateCaptcha() {
      const num1 = Math.floor(Math.random() * 10) + 1;
      const num2 = Math.floor(Math.random() * 10) + 1;
      captchaQuestion.textContent = `${num1} + ${num2}`;
      captchaExpected.value = num1 + num2;
    }

    generateCaptcha();

    // Set Date of Purchase limits (from 1 year ago to today)
    const dateInput = document.getElementById('purchase-date');
    if (dateInput) {
      const today = new Date();
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(today.getFullYear() - 1);
      const formatDate = (d) => d.toISOString().split('T')[0];
      dateInput.max = formatDate(today);
      dateInput.min = formatDate(oneYearAgo);
    }

    function showError(input, message) {
      input.classList.add('is-invalid');
      input.style.borderColor = 'red';
      let errorSpan = input.nextElementSibling;
      if (!errorSpan || !errorSpan.classList.contains('error-msg')) {
        errorSpan = document.createElement('span');
        errorSpan.classList.add('error-msg');
        errorSpan.style.color = 'red';
        errorSpan.style.fontSize = '12px';
        errorSpan.style.display = 'block';
        errorSpan.style.marginTop = '4px';

        if (input.type === 'checkbox') {
          input.parentElement.parentElement.appendChild(errorSpan);
        } else {
          input.parentNode.insertBefore(errorSpan, input.nextSibling);
        }
      }
      errorSpan.textContent = message;
    }

    function clearErrors() {
      const inputs = form.querySelectorAll('input, select, textarea');
      inputs.forEach((input) => {
        input.classList.remove('is-invalid');
        input.style.borderColor = '';
      });
      const errors = form.querySelectorAll('.error-msg');
      errors.forEach((err) => err.remove());
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      clearErrors();
      let hasError = false;

      if (!form.name.value.trim()) {
        showError(form.name, 'Please enter your name.');
        hasError = true;
      }

      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(form.email.value.trim())) {
        showError(form.email, 'Please enter a valid email address.');
        hasError = true;
      }

      const phoneValue = form.phone.value.trim().replace(/\D/g, '');
      if (phoneValue.length !== 10) {
        showError(form.phone, 'Please enter a valid 10-digit phone number.');
        hasError = true;
      }

      if (!form.city.value.trim()) {
        showError(form.city, 'Please enter your city.');
        hasError = true;
      }

      if (!form.date.value) {
        showError(form.date, 'Please select the date of purchase.');
        hasError = true;
      }

      if (!form.invoice_no.value.trim()) {
        showError(form.invoice_no, 'Please enter your invoice number.');
        hasError = true;
      }

      if (!form.purchased_source.value) {
        showError(form.purchased_source, 'Please select a purchase source.');
        hasError = true;
      }

      if (!form.product.value) {
        showError(form.product, 'Please select a product.');
        hasError = true;
      }

      if (!form.age_group.value) {
        showError(form.age_group, "Please select the user's age group.");
        hasError = true;
      }

      if (!form.gender.value) {
        showError(form.gender, "Please select the user's gender.");
        hasError = true;
      }

      if (!form.primary_users.value) {
        showError(form.primary_users, 'Please select the primary users.');
        hasError = true;
      }

      const termCheckbox = form.querySelector('.kl-form-check-input');
      if (termCheckbox && !termCheckbox.checked) {
        showError(termCheckbox, 'Please agree to the Terms & Conditions.');
        hasError = true;
      }

      if (parseInt(captchaAnswer.value.trim(), 10) !== parseInt(captchaExpected.value, 10)) {
        showError(captchaAnswer, 'Incorrect CAPTCHA answer. Please try again.');
        generateCaptcha();
        captchaAnswer.value = '';
        hasError = true;
      }

      if (hasError) {
        const firstError = form.querySelector('.is-invalid');
        if (firstError) firstError.focus();
        return;
      }

      const formData = {
        name: form.name.value,
        email: form.email.value,
        phone: phoneValue,
        city: form.city.value,
        date: form.date.value,
        invoice_no: form.invoice_no.value,
        purchased_source: form.purchased_source.value,
        product: form.product.value,
        age_group: form.age_group.value,
        gender: form.gender.value,
        primary_users: form.primary_users.value,
        message: form.message.value,
        page_url: window.location.href,
      };

      try {
        await fetch(
          'https://script.google.com/macros/s/AKfycbxwapCXfezl2NLWAgdUf-BCIWux7P66xHGuI6pbnO2M4uFK8BpJwnZwWRUymOjwQjs/exec',
          {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
          }
        );

        popup.style.display = 'flex';
        form.reset();
        generateCaptcha();
      } catch (err) {
        alert('Error submitting form. Please try again.');
        console.error(err);
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popup.style.display = 'none';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cxm-apply"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {

  const form = document.getElementById("cxm-apply");
  const popup = document.getElementById("warranty-popup");
  const closeBtn = document.getElementById("close-popup");

  // CAPTCHA Logic
  const captchaQuestion = document.getElementById('cxm-captcha-question');
  const captchaAnswer = document.getElementById('cxm-captcha-answer');
  const captchaExpected = document.getElementById('cxm-captcha-expected');

  function generateCaptcha() {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    captchaQuestion.textContent = `${num1} + ${num2}`;
    captchaExpected.value = num1 + num2;
  }

  generateCaptcha();

  // Date Logic
  const dateInput = document.getElementById('cxm-warranty-date');
  if (dateInput) {
    const today = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    const formatDate = (d) => d.toISOString().split('T')[0];
    dateInput.max = formatDate(today);
    dateInput.min = formatDate(oneYearAgo);
  }

  function showError(input, message) {
    input.style.borderColor = 'red';
    let errorSpan = input.nextElementSibling;
    if (!errorSpan || !errorSpan.classList.contains('cxm-error-msg')) {
      errorSpan = document.createElement('span');
      errorSpan.classList.add('cxm-error-msg');
      errorSpan.style.color = 'red';
      errorSpan.style.fontSize = '12px';
      errorSpan.style.display = 'block';
      errorSpan.style.marginTop = '4px';

      if (input.type === 'checkbox') {
        input.parentElement.parentElement.appendChild(errorSpan);
      } else {
        input.parentNode.insertBefore(errorSpan, input.nextSibling);
      }
    }
    errorSpan.textContent = message;
  }

  function clearErrors() {
    const inputs = form.querySelectorAll('input, select, textarea');
    inputs.forEach((input) => {
      input.style.borderColor = '';
    });
    const errors = form.querySelectorAll('.cxm-error-msg');
    errors.forEach((err) => err.remove());
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    clearErrors();
    let hasError = false;

    if (!form.name.value.trim()) {
      showError(form.name, 'Please enter your name.');
      hasError = true;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(form.email.value.trim())) {
      showError(form.email, 'Please enter a valid email address.');
      hasError = true;
    }

    const phoneValue = form.phone.value.trim().replace(/\D/g, '');
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phoneRegex.test(phoneValue)) {
      showError(form.phone, 'Please enter a valid 10-digit phone number.');
      hasError = true;
    }

    if (!form.city.value.trim()) {
      showError(form.city, 'Please enter your city.');
      hasError = true;
    }

    if (!form.date.value) {
      showError(form.date, 'Please select the date of purchase.');
      hasError = true;
    } else {
      const selectedDate = new Date(form.date.value);
      const currentDate = new Date();
      currentDate.setHours(23, 59, 59, 999);
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
      oneYearAgo.setHours(0, 0, 0, 0);

      if (selectedDate > currentDate) {
        showError(form.date, 'Purchase date cannot be in the future.');
        hasError = true;
      } else if (selectedDate < oneYearAgo) {
        showError(form.date, 'Purchase date must be within the last 1 year.');
        hasError = true;
      }
    }

    if (!form.invoice_no.value.trim()) {
      showError(form.invoice_no, 'Please enter your invoice number.');
      hasError = true;
    }

    if (!form.purchased_source.value) {
      showError(form.purchased_source, 'Please select a purchase source.');
      hasError = true;
    }

    if (!form.product.value) {
      showError(form.product, 'Please select a product.');
      hasError = true;
    }

    if (!form.age_group.value) {
      showError(form.age_group, "Please select the user's age group.");
      hasError = true;
    }

    if (!form.gender.value) {
      showError(form.gender, "Please select the user's gender.");
      hasError = true;
    }

    if (!form.primary_users.value) {
      showError(form.primary_users, 'Please select the primary users.');
      hasError = true;
    }

    const termCheckbox = form.querySelector('input[name="terms"]');
    if (termCheckbox && !termCheckbox.checked) {
      showError(termCheckbox, 'Please agree to the Terms & Conditions.');
      hasError = true;
    }

    if (parseInt(captchaAnswer.value.trim(), 10) !== parseInt(captchaExpected.value, 10)) {
      showError(captchaAnswer, 'Incorrect CAPTCHA answer. Please try again.');
      generateCaptcha();
      captchaAnswer.value = '';
      hasError = true;
    }

    if (hasError) return;

    const payload = {
      name: form.name.value,
      email: form.email.value,
      phone: phoneValue,
      city: form.city.value,
      date: form.date.value,
      invoice_no: form.invoice_no.value,
      purchased_source: form.purchased_source.value,
      product: form.product.value,
      message: form.message.value,
      page_url: window.location.href,
      // NEW FIELDS
      age_group: form.age_group.value,
      gender: form.gender.value,
      primary_users: form.primary_users.value
    };

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbxHU-r1wmvRbg2847D4fyNDZChxB469OJzdtI-7vSJckvUJ8QwVrNYr5ituZ4Q6zhc/exec",
        {
          method: "POST",
          mode: "no-cors",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      popup.style.display = "flex";
      form.reset();
      generateCaptcha();
    } catch (err) {
      alert("Error submitting form. Please try again.");
    }
  });

  closeBtn.addEventListener("click", () => {
    popup.style.display = "none";
  });

});

  } catch(e) { console.error(e); }
})();
})();
